var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.738 2.798-2.14 2.849v.046L10 5.236v1.55l-3.403-.432v.068l2.164 2.734-1.42.82-1.375-3.19h-.045L4.48 10l-1.284-.82 2.14-2.782v-.067L2 6.786v-1.55l3.313.433v-.045L3.195 2.82l1.374-.798 1.397 3.192h.045L7.385 2l1.353.798Z",
    fill: "#F22F22"
  })));
};
export default SvgStar;